<template>
  <div>
    <TopNavbar  />
    <div class="profile-layout-simulacrum-result">
      <nav class="nav">
        <li class="nav-item go-to-dashboard">
          <router-link :to="'/Dashboard/'" class="nav-link">
            <font-awesome-icon icon="fas fa-arrow-left" />
            <span>Salir</span>
          </router-link>
        </li>
      </nav>
      <div class="main-simulacrum-result pb-5">
        <header class="section-header py-5 head-simuresult">
          <div class="row justify-content-center" v-if="simulacrums.key === 'CLASIFICACIONES' ">
            <div class="col-md-4">
              <b-img :src="$assetImport('@/assets/images/mobius-thankyou.png')" alt="Agradecimiento Mobius" style="max-width: 100%" class="pb-5"></b-img>
            </div>
          </div>
          <div class="row justify-content-center" v-if="simulacrums.key === 'SEMI-FINAL' ">
            <div class="col-md-4">
              <b-img :src="$assetImport('@/assets/images/mobius-thankyou-sf.png')" alt="Agradecimiento Mobius" style="max-width: 100%" class="pb-5"></b-img>
            </div>
          </div>
          <h1 class="h4 text-primary mb-0 mt-2"> {{simulacrums.title}}</h1>

          <div class="container ">
            <div class=" pb-3 center-content" v-for="(simulacrumsResult, name, index) in simulacrumsResults"
                :key="index+100">
            <div class="" v-if=" name === 'generalResult'">
              <div class="col-sm-12 col-md-3">
                <h1 class="h5 text-dark mb-0 mt-2"><span class="h4 text-primary mb-0 mt-2">
                  Resultado general</span></h1>
              </div>
              <div class="col-sm-12 col-md-3">
                {{totalQuestions(simulacrumsResult)}} % correctas
              </div>
              <div class="col-sm-12 col-md-3">
                {{simulacrumsResult.correct}} correctas / {{simulacrumsResult.incorrect}} incorrectas
              </div>
            </div>
          </div>
          </div>


          <div class="col d-flex justify-content-between pt-5 pb-3 simu-header infosimulacrum">
            <div class="" >
              <b-card-group v-if="!finished" deck class="pd-0">
                <div v-if="this.minutesTimeSpend > 60">
                  <div>Tiempo total</div>
                    <b-card class="text-center minute-card card-spend">
                      <b-card-text class="minute-body icon-card pd-0" >
                        <font-awesome-icon icon="fa-clock" class="icon-card"/>
                        &nbsp;&nbsp;&nbsp; {{timeHoursTotal}}
                        <span v-if="timeMinutesTotal < 10">: 0{{timeMinutesTotal}} </span>
                        <span v-else>: {{timeMinutesTotal}} </span>
                        :  {{this.secondsTimeSpend}}
                      </b-card-text>
                        <br>
                    </b-card>
                </div>

                <div v-else>
                  <div>Tiempo total</div>
                    <b-card class="text-center minute-card card-spend">
                      <b-card-text class="minute-body icon-card pd-0" >
                        <font-awesome-icon icon="fa-clock" class="icon-card"/>
                        &nbsp;&nbsp;&nbsp;
                        <span v-if="this.minutesTimeSpend < 10">0{{this.minutesTimeSpend}} </span>
                        <span v-else> {{this.minutesTimeSpend}} </span>
                        :  {{this.secondsTimeSpend}}
                      </b-card-text>
                        <br>
                    </b-card>
                </div>

                <div v-if="simulacrums.duration > 60">
                  <div>Tiempo límite</div>
                  <b-card class="text-center minute-card card-duration">
                    <b-card-text class="minute-body icon-card">
                      <font-awesome-icon icon="fa-clock" class="icon-card"/>
                      &nbsp;&nbsp;&nbsp; {{getTimeHours(simulacrums)}} :
                      <span v-if="getTimeMinutes(simulacrums) < 10">0{{getTimeMinutes(simulacrums)}}</span>
                      <span v-else>{{getTimeMinutes(simulacrums)}}</span>
                      : 00&nbsp;&nbsp;</b-card-text>
                    <br>
                  </b-card>
                </div>

                <div v-else>
                  <div>Tiempo límite</div>
                  <b-card class="text-center minute-card card-duration">
                    <b-card-text class="minute-body icon-card">
                      <font-awesome-icon icon="fa-clock" class="icon-card"/> &nbsp;&nbsp;&nbsp; {{simulacrums.duration}} : 00&nbsp;&nbsp;</b-card-text>
                    <br>
                  </b-card>
                </div>
              </b-card-group>
            </div>
          </div>
        </header>
        <section class="container-fluid section-container">

          <!-- Types of thinking -->
<!--          <div class="container">-->

<!--            <div class="card ">-->
<!--              <div class="row div-card-result" v-for="(simulacrumsResult, name, index) in simulacrumsResults"-->
<!--              :key="index + 300">-->
<!--              <div v-if="name !== 'generalResult'">-->
<!--                <b-card no-body img-top>-->
<!--                  <template #header>-->
<!--                        <div class="py-2">-->
<!--                          <p class="mb-1">-->
<!--                            {{name}}-->
<!--                          </p>-->
<!--                          <p class="mb-1">-->
<!--                            <b></b> {{totalQuestions(simulacrumsResult)}} %-->
<!--                            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;-->
<!--                            {{simulacrumsResult.correct}} correcta / {{simulacrumsResult.incorrect}} incorrectas-->
<!--                          </p>-->

<!--                          <div class="progress-bar">-->
<!--                            <div class="progress-bar-inner bg-success success-color" ></div>-->
<!--                          </div>-->
<!--                          <div class="d-flex mt-2">-->
<!--                            <button v-b-toggle="'collapse' + index" class="btn btn-secondary p-2 d-block w-100 ml-2" v-on:click="(getshowButton(index))">-->
<!--                              <template v-if="show1 !== index">Ver preguntas</template>-->
<!--                              <template v-else>Ocultar</template>-->
<!--                              </button>-->
<!--                          </div>-->

<!--                        </div>-->

<!--                      </template>-->
<!--                      <b-card-body >-->
<!--                        <b-collapse v-for="simulacrumResultCategory in simulacrumsResult.questions"-->
<!--                          :key="simulacrumResultCategory.id" v-bind:id="'collapse' + index" >-->
<!--                      <b-card style="padding: 0">-->
<!--                        <div class="card-container card-result module line-clamp" maxlength="1">-->
<!--                          &lt;!&ndash; <p class="mb-1" >-->
<!--                            {{ simulacrumResultCategory.description }}-->
<!--                          </p> &ndash;&gt;-->
<!--                          <div class="module line-clamp">-->
<!--                            <p>-->
<!--                              {{ simulacrumResultCategory.description }}-->
<!--                            </p>-->
<!--                          </div>-->

<!--                          <p v-bind:class="[{'correct-template' : simulacrumResultCategory.correct},{'incorrect-template' : !simulacrumResultCategory.correct}]">-->
<!--                            <template v-if="simulacrumResultCategory.correct">correcta</template>-->
<!--                            <template v-else>incorrecta</template>-->
<!--                          </p>-->
<!--                        </div>-->
<!--                      </b-card>-->
<!--                    </b-collapse>-->
<!--                  </b-card-body>-->
<!--                </b-card>-->
<!--              </div>-->
<!--            </div>-->
<!--            </div>-->
<!--          </div>-->
          <!-- End Types of thinking -->
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/TopNavbar.vue";
import axios from "axios";
import bxSpreadsheet from "@iconify/icons-bx/bx-spreadsheet";

export default {
  name: "Dashboard",
  props: ["topic"],
  components: {
    TopNavbar,
  },
  data: () => {
    return {
      userData: {},
      simulacrums: [],
      simulacrumsResults: [],
      minutesTimeSpend: '',
      secondsTimeSpend: '',
      selectedModule: {},
      knowledgeAreas: [],
      icons: {
        bxSpreadsheet,
      },
      openMenu: false,
      show1: true,
      simulacrumId: null,
      timeSpend: 0,
      timeMinutes: 0,
      timeMinutesTotal: 0,
      timeHours: 0,
      timeHoursTotal: 0,
      minutesbool: false,
      finished: false,
    };
  },
  mounted: function () {


    this.loadSimulacrumsResult();
    this.loadSimulacrums();
    let loader = this.$loading.show({});

      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/knowledgeAreas/", {
          params: { },
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then((response) => {
          loader.hide();
          let data = response.data;
          data.sort(function (a, b) {
            const textA = a.description ? a.description.toUpperCase() : "";
            const textB = b.description ? b.description.toUpperCase() : "";
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });
          this.knowledgeAreas = data;
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });

    this.userData = this.$store.state.auth.data;
  },
  watch: {
    selectedModule: function() {

    },
  },
  methods: {
    showPopup() {
      const surveyUrl = 'https://docs.google.com/forms/d/e/1FAIpQLScVsF8QpDm_AUIQP49lLuyK5zxMMqzQXwaRTKo_iEmjb7kqaw/viewform?usp=sf_link';
      const popup = window.open(surveyUrl, 'Encuesta', 'height=600,width=800');
      if (window.focus) {
        popup.focus();
      }
    },
    getshowButton(index) {
      if (this.show1 === index) {
        this.show1 = 9999;
      } else {
        this.show1 = index;
      }
      this.refreshMath();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn');
      this.refreshMath()
    },
    totalQuestions(simulacrumsResult) {
      let total = parseInt(simulacrumsResult.correct) + parseInt(simulacrumsResult.incorrect);

      let result1 =  parseInt(simulacrumsResult.correct) * 100;

      let result2 = result1 / total;

      let n = result2.toFixed(2);

      return n;
    },
    loadSimulacrums() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/getUserInfo/" + this.simulacrumId , {

          params: { categoryKey: this.topic },
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem("token")
          }
        })
        .then((response) => {
          loader.hide();
          console.log(response)
          if(response.data === '') {
            this.simulacrums = [];
            return;
          }
          let data= response.data;

          /*data.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });*/

          this.simulacrums = data;
          this.timeSpend = this.simulacrums.simulacrumRegistry.timeSpend;
          this.minutesFinished();
          if (this.simulacrums.key === 'SEMI-FINAL' && localStorage.getItem("surveyDisplayed-sf") !== "yes") {
            localStorage.setItem("surveyDisplayed-sf", "yes")
            setTimeout(  this.showPopup(), 5000);
          }
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    minutesFinished() {
      let seconds = this.timeSpend;
      const minutes = 60;

      this.minutesTimeSpend = Math.floor(seconds / minutes);
      this.secondsTimeSpend = seconds - this.minutesTimeSpend *60;

      if (this.minutesTimeSpend >= this.simulacrums.duration) {
        this.minutesTimeSpend = this.simulacrums.duration;
        this.secondsTimeSpend = '00';
      }

      if (this.minutesTimeSpend > 60) {
        this.timeHoursTotal = Math.floor(this.minutesTimeSpend / 60);
        this.timeMinutesTotal = this.minutesTimeSpend % 60;

        return true;
      } else {
        return false;
      }

    },
    convertTime(simulacrums){

      this.timeMinutes = simulacrums.duration;
      this.timeHours = Math.floor(this.timeMinutes / 60);
      this.timeMinutes = this.timeMinutes % 60;

      if (simulacrums.duration > 60) {
        return true;
      }else{
        return false;
      }
    },
    getTimeHours(simulacrum) {
      let timeMinutes = simulacrum.duration;
      return Math.floor(timeMinutes / 60);
    },
    getTimeMinutes(simulacrum) {
      let timeMinutes = simulacrum.duration;
      return timeMinutes % 60;
    },
    loadSimulacrumsResult() {
      this.simulacrumId = this.$route.params.id;
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/getSummaryResults/" + this.simulacrumId,
          {
            params: { page: this.currentPage, size: this.perPage, sort: 'DESC', },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data === '') {
            this.simulacrumsResults = [];
            return;
          }
          let data = response.data;

          /*data.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });*/


            console.log(data);
            this.simulacrumsResults = data;
            console.log(this.simulacrumsResults)

            for(let simu of this.simulacrumsResults){
                console.log(simu);
            }

        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    loadMath() {
      setTimeout(()=> {
          this.$nextTick(function() {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src =
              "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
            document.getElementsByTagName("head")[0].appendChild(script);
          });
        }
        ,50);

    },
    refreshMath() {
      setTimeout(()=> {
          this.$nextTick(function() {
            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
          });
        }
        ,200);

    },

    goToExerciseSimulacrum(topic) {
      this.$router.push(`/simulacrum/${topic}`);
    },
  },
  beforeMount() {

  this.loadMath();
  }
};
</script>

<style src="@/assets/css/app.css" scoped></style>
